import { omniAtom } from "src/utils/atoms";

const prefix = "planogram3d";

export const planogram3dCameraStyleAtom = omniAtom<"FRONT" | "3D">({
  prefix,
  key: "cameraType",
  value: "FRONT",
});
